module.exports = __webpack_public_path__ + "img/barrel-banner.56d1d9a4.png";